import { Link } from "react-router-dom";

export const Footer = () => (
  <footer data-testid="site-footer" className="py-16 border-t border-sand-200">
    <div className="max-w-6xl mx-auto px-6 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-8">
      <div>
        <p className="font-serif italic text-3xl tracking-widest text-sand-900">Frank en Vrij</p>
        <p className="mt-3 font-sans text-sm font-light text-sand-900/50">
          Nederlandstalige muziek &amp; verhalen, uit de stilte.
        </p>
      </div>
      <div className="flex items-center gap-8 font-sans text-xs font-light tracking-[0.2em] uppercase text-sand-900/50">
        <a href="#muziek" data-testid="footer-link-muziek" className="hover:text-terracotta-500 transition-colors">Muziek</a>
        <a href="#verhalen" data-testid="footer-link-verhalen" className="hover:text-terracotta-500 transition-colors">Verhalen</a>
        <Link to="/admin" data-testid="footer-admin-link" className="hover:text-terracotta-500 transition-colors">Studio</Link>
      </div>
    </div>
    <p className="max-w-6xl mx-auto px-6 mt-12 font-sans text-xs font-light text-sand-900/40">
      © {new Date().getFullYear()} Frank en Vrij — met stilte gemaakt.
    </p>
  </footer>
);
